import ComponentCard from "../../components/common/ComponentCard";
import QuizAttemptComponent from "../../components/attempts/QuizAttemptComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

const QuizAttempts = () => {
    return (
        <>
            <PageMeta title="Danh sách bài làm của học viên" description="Trang danh sách bài làm của học viên"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <QuizAttemptComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default QuizAttempts;